// GroupBySelector.js - FIXED: Prevents page refresh
import React from 'react';
import { List, User, Building2, FolderOpen, UserCheck } from 'lucide-react';

const GroupBySelector = ({ groupBy, onGroupByChange, userRole, compact = false }) => {
  const groupOptions = [
    { value: 'none', label: 'No Grouping', icon: List },
    { value: 'user', label: 'By User', icon: User },
    { value: 'client', label: 'By Client', icon: Building2 },
    { value: 'project', label: 'By Project', icon: FolderOpen },
  ];

  if (userRole === 'admin' || userRole === 'manager') {
    groupOptions.splice(2, 0, { value: 'role', label: 'By Role', icon: UserCheck });
  }

  // CRITICAL FIX: Prevent default and stop propagation
  const handleClick = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    onGroupByChange(value);
  };

  return (
    <div className={compact ? "p-0 bg-transparent border-0 shadow-none" : "bg-white rounded-lg shadow-sm border border-slate-200 p-4"}>
      <div className={`flex items-center ${compact ? "justify-end" : "justify-between"}`}>
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-slate-700">Group by:</span>
          <div className="flex items-center bg-slate-100 rounded-lg p-1">
            {groupOptions.map(({ value, label, icon: Icon }) => (
              <button
                key={value}
                type="button"
                onClick={(e) => handleClick(e, value)}
                className={`flex items-center space-x-2 px-3 py-1.5 rounded-md text-sm transition-colors ${
                  groupBy === value
                    ? 'bg-white text-blue-600 shadow-sm'
                    : 'text-slate-600 hover:text-slate-800'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span>{label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupBySelector;